import React from "react";

function Facilities() {
    const facilities = [
        "Treatment for all common health problems.",
        "Availability of Anti Snake Venom and Anti Rabies Vaccine.",
        "Full equipped ambulance(24X7).",
        "Outpatient Consultations on daily OPD services for general medical issues.",
        "Specialist consultations (Scheduled visits) regular visits by specialist.",
        "Basic Medical check-ups (BP, Sugar Level, fever etc.,)",
        "Referral or transport to tie-up hospitals for advanced care.",
        "Essential Medicines available from the campus in-house pharmacy.",
        "Separate wards for male and female.",
        "Blood/urine Sample collection and investigation on a bi-weekly basis from Apollo Diagnostics Limited.",
        "Availability of all emergency equipment's- Defibrillator, Multipara cardiac Monitor, ECG machine, Oxygen concentrators, Suction apparatus.",
        "Timely providing health education.",
        "Medical Reimbursement on CGHS rates.",
        "Minor Treatment & First aid for wounds, allergies, infections etc.",
    ];
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <h1>Facilities</h1>
            <ul>
                {facilities.map((facility, index) => (
                    <li
                        key={index}
                        className="caboutus"
                        style={{ display: "flex", flexDirection: "row" }}
                    >
                        <i
                            className="icon fal fas fa-caret-right pl-5"
                            style={{
                                display: "block",
                                alignSelf: "flex-start",
                                marginTop: "0.31lh",
                            }}
                        />
                        <p className="pl-5">{facility}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Facilities;
